import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "../../../axios-order";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from "@mui/material/CircularProgress";

const OAuthCard = () => {
  const history = useHistory();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [domain, setDomain] = useState(".in");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const location = params.get("location");
    const accountsServer = params.get("accounts-server");
    //const resolvedDomain = location ? `.${location}` : ".in";
    const resolvedDomain = "." + new URL(accountsServer).hostname.split(".").pop();
    setDomain(resolvedDomain);

    if (code) {
      axios.post("/save_zoho_organisations_data", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        url: window.location.href,  // full URL sent as-is
      })
        .then((res) => {
          if (res.data.status) {
            setStatus("success");
            setMessage(res.data.message || "Zoho connected successfully!");
            setOrganizations(res.data.organizations || []);
          } else {
            setStatus("error");
            setMessage(res.data.message || "Authorization failed.");
          }
        })
        .catch((err) => {
          setStatus("error");
          setMessage(
            err.response?.data?.message || "Something went wrong. Please try again."
          );
        });
    } else {
      setStatus("error");
      setMessage("No authorization code found in the URL.");
    }
  }, []);

  const handleClose = () => {
    window.location.href = "/BusinessEntityDetails";
  };

  const handleCheckbox = (org) => {
    if (selectedOrg && selectedOrg.organization_id === org.organization_id) {
      setSelectedOrg(null);
    } else {
      setSelectedOrg(org);
    }
  };

  const handleSave = () => {
    axios
      .put("/connectioninfo_put_api", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        source_system: "ZOHO",
        domain: domain,
        connection_info: {
          organisation_id: selectedOrg.organization_id,
          name: selectedOrg.name,
        },
      })
      .then((res) => {
        window.location.href = "/BusinessEntityDetails";
      })
      .catch((err) => {
        setMessage(
          err.response?.data?.message || "Failed to save organisation. Please try again."
        );
      });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          minWidth: "500px",
          maxWidth: "680px",
          width: "90%",
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: "#03406d",
            padding: "16px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <h2
            style={{
              margin: 0,
              color: "#fff",
              fontFamily: "Dosis",
              fontWeight: 700,
              fontSize: "20px",
            }}
          >
            Organisation Details
          </h2>
          <button
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "22px",
              cursor: "pointer",
              color: "#fff",
              lineHeight: 1,
              padding: "0 4px",
            }}
          >
            ✕
          </button>
        </div>

        {/* Scrollable Body */}
        <div style={{ overflowY: "auto", padding: "24px" }}>

          {/* Loading */}
          {status === "loading" && (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <CircularProgress style={{ color: "#03406d" }} size={48} />
              <p style={{ color: "#666", marginTop: "16px", fontSize: "16px" }}>
                Please wait while we complete the authorization...
              </p>
            </div>
          )}

          {/* Error */}
          {status === "error" && (
            <div style={{ textAlign: "center", padding: "30px 0" }}>
              <ErrorOutlineIcon style={{ fontSize: "64px", color: "#f44336" }} />
              <p style={{ color: "#555", marginTop: "12px", fontSize: "16px" }}>{message}</p>
              <button
                onClick={handleClose}
                style={{
                  backgroundColor: "#03406d",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "10px 24px",
                  fontSize: "16px",
                  fontFamily: "Dosis",
                  fontWeight: 600,
                  cursor: "pointer",
                  marginTop: "16px",
                  width: "100%",
                }}
              >
                Go Back to Business Entity
              </button>
            </div>
          )}

          {/* Success */}
          {status === "success" && (
            <>
              {/* Success message */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "20px",
                  backgroundColor: "#f0faf0",
                  border: "1px solid #c3e6c3",
                  borderRadius: "8px",
                  padding: "10px 16px",
                }}
              >
                <CheckCircleOutlineIcon style={{ fontSize: "24px", color: "#4caf50" }} />
                <span style={{ color: "#2e7d32", fontWeight: 600, fontSize: "16px" }}>
                  {message}
                </span>
              </div>

              {/* Organizations Table */}
              {organizations.length > 0 && (
                <>
                  <p
                    style={{
                      color: "#03406d",
                      fontWeight: 600,
                      marginBottom: "12px",
                      fontSize: "16px",
                    }}
                  >
                    Select an Organisation:
                  </p>

                  {/* Search Input with icon */}
                  <div style={{
                    position: "relative",
                    marginBottom: "12px",
                  }}>
                    <input
                      type="text"
                      placeholder="Search organisation name..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 12px 10px 34px",
                        border: "1px solid #dde3ea",
                        borderRadius: "6px",
                        fontSize: "14px",
                        boxSizing: "border-box",
                        outline: "none",
                        color: "#333",
                        backgroundColor: "#f7fafd",
                      }}
                    />
                  </div>

                  <div style={{ border: "1px solid #dde3ea", borderRadius: "8px", overflow: "hidden", marginBottom: "20px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#e8eef5" }}>
                          <th style={thStyle}>Select</th>
                          <th style={thStyle}>Organisation ID</th>
                          <th style={thStyle}>Name</th>
                          <th style={thStyle}>Country</th>
                        </tr>
                      </thead>
                      <tbody>
                        {organizations
                          .filter((org) =>
                            org.name.toLowerCase().includes(searchTerm.toLowerCase())
                          )
                          .map((org, index) => {
                            const isSelected =
                              selectedOrg &&
                              selectedOrg.organization_id === org.organization_id;
                            const isDisabled = selectedOrg && !isSelected;

                            return (
                              <tr
                                key={index}
                                onClick={() => !isDisabled && handleCheckbox(org)}
                                style={{
                                  backgroundColor: isSelected
                                    ? "#dceefb"
                                    : index % 2 === 0
                                      ? "#fafafa"
                                      : "#fff",
                                  cursor: isDisabled ? "not-allowed" : "pointer",
                                  borderTop: "1px solid #eee",
                                  opacity: isDisabled ? 0.5 : 1,
                                  transition: "background-color 0.15s",
                                }}
                              >
                                <td style={{ ...tdStyle, textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    checked={!!isSelected}
                                    disabled={!!isDisabled}
                                    onChange={() => handleCheckbox(org)}
                                    style={{
                                      cursor: isDisabled ? "not-allowed" : "pointer",
                                      width: "16px",
                                      height: "16px",
                                      accentColor: "#03406d",
                                    }}
                                  />
                                </td>
                                <td style={tdStyle}>{org.organization_id}</td>
                                <td style={{ ...tdStyle, fontWeight: isSelected ? 600 : 400 }}>
                                  {org.name}
                                </td>
                                <td style={tdStyle}>{org.country}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  {/* Save Button */}
                  <button
                    onClick={handleSave}
                    disabled={!selectedOrg}
                    style={{
                      backgroundColor: selectedOrg ? "#03406d" : "#b0bec5",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "12px 24px",
                      fontSize: "16px",
                      fontFamily: "Dosis",
                      fontWeight: 600,
                      cursor: selectedOrg ? "pointer" : "not-allowed",
                      width: "100%",
                      transition: "background-color 0.2s",
                    }}
                  >
                    Save Organisation
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const thStyle = {
  padding: "11px 14px",
  textAlign: "left",
  fontSize: "15px",
  fontWeight: 700,
  color: "#03406d",
};

const tdStyle = {
  padding: "11px 14px",
  fontSize: "15px",
  color: "#333",
};

export default OAuthCard;